import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./AllProductCss/AllProduct.css";
import AdminLayout from "../AdminLayout";
import TableData from "./TableData";
import useProductHook from "./hooks/useProductHook";

const AllProduct = () => {
  const { productHeaders, productData, fetchAllProductsTableData } =
    useProductHook();

  useEffect(() => {
    fetchAllProductsTableData();
  }, []);

  return (
    <div>
      <AdminLayout>
        <TableData
          tableHeader="All Products"
          tableHeaders={productHeaders}
          tableType="product"
          dataArr={productData}
        />
      </AdminLayout>
    </div>
  );
};

export default AllProduct;
